import { jsx as _jsx } from "react/jsx-runtime";
var REACT_ELEMENT_TYPE;

function _jsx2(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

import React, { Component } from 'react';
import GenericTouchable, { TOUCHABLE_STATE } from './GenericTouchable';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
/**
 * TouchableHighlight follows RN's implementation
 */

var _ref = /*#__PURE__*/_jsx2(View, {});

export default class TouchableHighlight extends Component {
  constructor(props) {
    super(props);

    this.showUnderlay = () => {
      if (!this.hasPressHandler()) {
        return;
      }

      this.setState({
        extraChildStyle: {
          opacity: this.props.activeOpacity
        },
        extraUnderlayStyle: {
          backgroundColor: this.props.underlayColor
        }
      });
      this.props.onShowUnderlay && this.props.onShowUnderlay();
    };

    this.hasPressHandler = () => this.props.onPress || this.props.onPressIn || this.props.onPressOut || this.props.onLongPress;

    this.hideUnderlay = () => {
      this.setState({
        extraChildStyle: null,
        extraUnderlayStyle: null
      });
      this.props.onHideUnderlay && this.props.onHideUnderlay();
    };

    this.onStateChange = (from, to) => {
      if (to === TOUCHABLE_STATE.BEGAN) {
        this.showUnderlay();
      } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        this.hideUnderlay();
      }
    };

    this.state = {
      extraChildStyle: null,
      extraUnderlayStyle: null
    };
  } // Copied from RN


  renderChildren() {
    if (!this.props.children) {
      return _ref;
    }

    const child = React.Children.only(this.props.children);
    return /*#__PURE__*/React.cloneElement(child, {
      style: StyleSheet.compose(child.props.style, this.state.extraChildStyle)
    });
  }

  render() {
    const {
      style = {},
      ...rest
    } = this.props;
    const {
      extraUnderlayStyle
    } = this.state;
    return /*#__PURE__*/_jsx(GenericTouchable, { ...rest,
      style: [style, extraUnderlayStyle],
      onStateChange: this.onStateChange,
      children: this.renderChildren()
    });
  }

}
TouchableHighlight.defaultProps = { ...GenericTouchable.defaultProps,
  activeOpacity: 0.85,
  delayPressOut: 100,
  underlayColor: 'black'
};
TouchableHighlight.propTypes = { ...GenericTouchable.publicPropTypes,
  activeOpacity: PropTypes.number,
  underlayColor: PropTypes.string,
  style: PropTypes.any,
  onShowUnderlay: PropTypes.func,
  onHideUnderlay: PropTypes.func
};